<template>
  <div class="questionnaire-data-statistics">
    <div class="app-region blank-l-h blank-r-h">
      <a-row type="flex">
        <a-col flex="1">
          <p>{{numberOne}}</p>
          <p>回收量</p>
        </a-col>
        <a-col flex="1">
          <p>{{numberTwo}}</p>
          <p>送达量</p>
        </a-col>
        <a-col flex="1">
          <p>{{numberThree}}</p>
          <p>回收率</p>
        </a-col>
      </a-row>
    </div>
    <div class="app-region blank-t-v blank-b-v blank-l-h blank-r-h">
      <a-row :gutter="[0, 32]">
        <a-col v-for="(value, index) in data" :key="index">
          <p class="title">{{index + 1}}、{{value.title}}</p>
          <template v-if="value.type === 1">
            <div class="bar" v-for="(m, n) in value.options" :key="n">
              <div class="percent" :style="{width: `${m.ratio * 100}px`}"></div>
              <a-row :gutter="[32, 32]" type="flex">
                <a-col flex="1">{{m.name}}</a-col>
                <a-col>{{m.total}}</a-col>
                <a-col>{{`${(m.ratio * 100).toFixed(2)}%`}}</a-col>
              </a-row>
            </div>
          </template>
          <template v-if="value.type === 2">
            <a-table :columns="table.columns" :data-source="value.options" rowKey="username" :pagination="false"></a-table>
          </template>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
  import QuestionnaireService from '@/io/questionnaire.js';

  export default {
    name: 'QuestionnaireDataStatistics',
    data() {
      return {
        id: this.$route.params.id,
        numberOne: 0,
        numberTwo: 0,
        numberThree: 0,
        data: [],
        table: {
          columns: [
            {
              title: '姓名',
              dataIndex: 'username'
            },
            {
              title: '回答',
              dataIndex: 'value'
            }
          ]
        }
      }
    },
    mounted () {
      this.initInfo();
      this.initPage();
    },
    methods: {
      initInfo() {
        QuestionnaireService.info(this.id).then(res => {
          this.numberOne = res.done_people;
          this.numberTwo = res.total_people;
          this.numberThree = res.total_people ? `${((res.done_people / res.total_people) * 100).toFixed(2)}%` : 0;
        }).catch(err => {});
      },
      initPage() {
        QuestionnaireService.statisticsList(this.id).then(res => {
          this.data = res.items.map(val => {
            val.type = 1;
            return val;
          }).concat(res.texts.map(val => {
            val.type = 2;
            return val;
          }));
        }).catch(err => {});
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../../assets/styles/tools.less';
  .questionnaire-data-statistics {
    .app-region {
      &:nth-of-type(1) {
        text-align: center;
        p {
          &:nth-of-type(1) {
            font-weight: bold;
            font-size: @font-size-base + 30;
            margin: @padding-sm 0 @padding-sm 0;
          }
          &:nth-of-type(2) {
            font-size: @font-size-lg;
            margin-bottom: @padding-lg;
          }
        }
      }
    }
    .title {
      margin-bottom: @padding-lg;
    }
    .bar {
      height: 50px;
      display: flex;
      align-items: center;
      background-color: @background-color-light;
      padding: 0 @padding-lg;
      position: relative;
      &:not(:last-of-type) {
        margin-bottom: @padding-sm;
      }
      & > * {
        flex: 1;
      }
      .percent {
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: @primary-color;
      }
    }
  }
</style>